export function joinProfessionalTitles(
  titles?: (string | null | undefined)[],
  prefixComma: boolean = true,
): string {
  const joined = (titles ?? [])
    .map((s) => (s ? s.trim() : ''))
    .filter(Boolean)
    .join(', ');

  if (joined.length === 0) {
    return '';
  }
  // If prefixComma is true, prepend a comma and space for use in name formatting
  return prefixComma ? ', ' + joined : joined;
}

export default joinProfessionalTitles;
